var UserBillingResource = function() {
  var self = this;

  self.delete = function(id, options) {
    request.delete($.extend(true, {
      url: '/api/user/current/billing/' + id
    }, options));
  };
};

window.userBillingResource = new UserBillingResource();